// ═══════════════════════════════════════════════════════════════════
//  modules/sanctions/ComptesLies.js
//  La liste blanche : des PAIRES de comptes autorisés à partager une
//  adresse, jamais une adresse entière (CDC §3.5).
// ═══════════════════════════════════════════════════════════════════

import { useCallback, useEffect, useState } from "react";
import { THEME } from "../../socle/theme";
import { dateCourte } from "./constantes";

const ORIGINE = {
  amorcage: { label: "Amorçage", color: THEME.textMuted },
  enquete: { label: "Enquête automatique", color: THEME.accent },
  ticket: { label: "Ticket / manuel", color: THEME.emerald },
};

export function ComptesLies({ api, peutGerer }) {
  const [paires, setPaires] = useState(null);
  const [erreur, setErreur] = useState(null);
  const [a, setA] = useState("");
  const [b, setB] = useState("");
  const [motif, setMotif] = useState("");

  const charger = useCallback(async () => {
    try { const r = await api.comptesLies(); setPaires(r.paires); setErreur(null); }
    catch (e) { setErreur(e.message); }
  }, [api]);
  useEffect(() => { charger(); }, [charger]);

  const agir = async (fn) => {
    try { await fn(); setA(""); setB(""); setMotif(""); await charger(); }
    catch (e) { setErreur(e.message); }
  };

  const champ = { background: THEME.surface, border: `1px solid ${THEME.border}`, color: THEME.text, borderRadius: 8, padding: "7px 10px", fontSize: 13, fontFamily: "inherit" };

  return (
    <div>
      <div style={{ background: THEME.emeraldDim, border: `1px solid ${THEME.emerald}`, borderRadius: 10, padding: "11px 14px", color: THEME.emerald, fontSize: 13, marginBottom: 14 }}>
        Une paire autorisée reste surveillée : si un troisième compte apparaît sur la même adresse,
        un nouveau dossier s'ouvre. C'est une autorisation, pas un blanc-seing.
      </div>

      {peutGerer && (
        <div style={{ background: THEME.panel, border: `1px solid ${THEME.border}`, borderRadius: 12, padding: 14, marginBottom: 14, display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
          <input placeholder="Pseudo A" value={a} onChange={(e) => setA(e.target.value)} style={{ ...champ, width: 150 }} />
          <input placeholder="Pseudo B" value={b} onChange={(e) => setB(e.target.value)} style={{ ...champ, width: 150 }} />
          <input placeholder="Motif — frères, couple, colocation…" value={motif}
            onChange={(e) => setMotif(e.target.value)} style={{ ...champ, flex: 1, minWidth: 200 }} />
          <button disabled={!a.trim() || !b.trim()}
            onClick={() => agir(() => api.lierComptes(a.trim(), b.trim(), motif))}
            style={{ ...champ, cursor: "pointer", color: THEME.emerald, borderColor: THEME.emerald, fontWeight: 700, opacity: a.trim() && b.trim() ? 1 : 0.4 }}>
            Autoriser la paire
          </button>
        </div>
      )}

      {erreur && <div style={{ color: THEME.red, marginBottom: 12 }}>{erreur}</div>}
      {!paires && <div style={{ color: THEME.textMuted }}>Chargement…</div>}
      {paires && paires.length === 0 && (
        <div style={{ background: THEME.panel, border: `1px dashed ${THEME.border}`, borderRadius: 14, padding: 40, textAlign: "center", color: THEME.textMuted }}>
          Aucune paire autorisée pour l'instant.
        </div>
      )}

      {paires && paires.map((p) => {
        const o = ORIGINE[p.origine] || ORIGINE.ticket;
        return (
          <div key={p.id} style={{ background: THEME.panel, border: `1px solid ${THEME.border}`, borderRadius: 10, padding: "11px 14px", marginBottom: 8, display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
            <span style={{ color: THEME.gold, fontWeight: 700, fontSize: 14 }}>{p.pseudo_a}</span>
            <span style={{ color: THEME.textDim }}>↔</span>
            <span style={{ color: THEME.gold, fontWeight: 700, fontSize: 14 }}>{p.pseudo_b}</span>
            <span style={{ color: o.color, fontSize: 11, fontWeight: 700 }}>{o.label}</span>
            <span style={{ color: THEME.textMuted, fontSize: 12.5, flex: 1, minWidth: 160 }}>{p.motif}</span>
            <span style={{ color: THEME.textDim, fontSize: 11 }}>{dateCourte(p.created_at)}{p.valide_par ? ` · ${p.valide_par}` : ""}</span>
            {peutGerer && (
              <button onClick={() => agir(() => api.delierComptes(p.id))}
                style={{ background: "transparent", border: `1px solid ${THEME.border}`, color: THEME.red, borderRadius: 6, padding: "4px 10px", cursor: "pointer", fontSize: 12, fontFamily: "inherit" }}>
                Retirer
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}
